// registerRTSP.tsx
import React, { FC, useEffect, useState, useRef } from 'react'
import { useAuth } from '../../../Provider/AuthProvider'
import { useLoading } from '../../../Provider/LoadingProvider'
import { createVisitor } from '../../../services/visitor'
import { printQRCode } from '../../../utils/printer'
import Button from '../../Form/Button'
import { entries, entriesApprovedEnum } from '../../../types/entries'
import NewCameraFiles from '../NewCameraFiles'
import { listByDestinationCode } from '../../../services/resident'
import { Toaster, toast } from 'sonner'
import { brand } from '../../../types/brand'
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow'
import AutoComplete from '../../Form/AutoComplete'
import { AccessConfig } from '../../../types/AccessConfig'
import Icon from '@ant-design/icons'
import { ReactComponent as waitInLobby } from '../../../assets/svg/waitInLobby.svg'
import { ReactComponent as leaveInLobby } from '../../../assets/svg/leaveInLobby.svg'
import { ReactComponent as noLeaveInLobby } from '../../../assets/svg/noLeaveInLobby.svg'
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  QrcodeOutlined,
  PhoneOutlined,
  LikeOutlined,
  DislikeOutlined,
  Loading3QuartersOutlined
} from '@ant-design/icons'
import './styles.scss'
import PlaceholderSvg from '../../PlaceholderSvg'
import { Fade } from '@mui/material'
import { LightTooltip } from '../../../components/tooltips/text'
import ContextMenu from '../ContextMenu'
import { typeQrEnumAbbreviationString } from '../../../types/qr'

type ModalCheckInCenterProps = {
  newEntrySocket: entries | undefined
  brands: brand[]
  camera: AccessConfig
}

const ModalCheckInCenter: FC<ModalCheckInCenterProps> = ({
  newEntrySocket,
  brands,
  camera
}) => {
  const [optionsDestinations, setOptionsDestinations] = useState<
    { label: string; value: string }[]
  >([])
  const [searchedValue, setSearchedValue] = useState('')
  const [TimeImg, setTimeImg] = useState<NodeJS.Timeout | null>(null)
  const [lastEntry, setlastEntry] = useState<entries | null | undefined>()
  const [okEntry, setOkEntry] = useState<boolean>()
  const [loadingCamera, setloadingCamera] = useState<boolean>(false)
  const preSelectBrand = localStorage.getItem(`${camera.name}SelectBrand2`)
  const [blinkDuration, setBlinkDuration] = useState(5)
  const [brandPhoto, setBrandPhoto] = useState<string | undefined>(undefined)
  const TimeClearqr: number = 30000
  useEffect(() => {
    const newBrand = brands.find(e => e.id === lastEntry?.brandId)?.photo
    setBrandPhoto(newBrand)
  }, [brands, lastEntry])

  const selectRef = useRef<HTMLInputElement>(null)
  const { user, token } = useAuth()
  const { startLoading, stopLoading } = useLoading()
  const [images, setImages] = useState<{
    photo: File | null
    DNI_A: File | null
    // DNI_B: File | null
  }>({
    photo: null,
    DNI_A: null
    // DNI_B: null
  })

  const [formValues, setFormValues] = useState({
    brand: preSelectBrand ? preSelectBrand : '',
    destinationCode: '',
    camera: camera.name
  })

  useEffect(() => {
    if (newEntrySocket) {
      if (!lastEntry || newEntrySocket.qrCode !== lastEntry.qrCode)
        if (
          !lastEntry ||
          newEntrySocket.destination !== lastEntry.destination ||
          newEntrySocket.cameraIn !== camera.name
        )
          return

      setlastEntry(newEntrySocket)

      if (
        ['APPROVED', 'REJECT', 'RECESSION', 'LEAVE', 'NO_LEAVE', 'UNANSWERED'].includes(
          `${newEntrySocket?.approved}`
        )
      )
        if (newEntrySocket.qrCode) {
          clearAndFocusTime(TimeClearqr)
        } else {
          clearAndFocusTime(15000)
        }
    }
  }, [newEntrySocket])

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null

    const minDuration = 0.1 // Mínima duración permitida
    const initialDuration = 5 // Duración inicial del parpadeo
    const totalEffectTime = 30000 // Tiempo total para llegar al mínimo (en milisegundos)
    const decrementInterval = 2100 // Frecuencia con la que disminuimos el tiempo (1 segundo)

    const startBlinkEffect = (currentDuration: number, remainingTime: number) => {
      if (remainingTime <= 0 || currentDuration <= minDuration) {
        setBlinkDuration(minDuration)
        setlastEntry(old => (old ? { ...old, approved: entriesApprovedEnum.CALLING } : null))
        return
      }
      if (timeout) clearTimeout(timeout)

      // Calcula el siguiente valor de la duración, reduciendo de forma proporcional
      const decrement = (initialDuration - minDuration) * (decrementInterval / totalEffectTime)
      const newDuration = currentDuration - decrement

      setBlinkDuration(newDuration >= minDuration ? newDuration : minDuration)

      // Espera a que la animación actual termine antes de volver a ajustar la duración
      timeout = setTimeout(() => {
        startBlinkEffect(newDuration, newDuration * 1000) // Ajusta el tiempo restante
      }, newDuration * 1000) // Espera exactamente lo que dura la animación actual antes de reducir más
    }

    if (lastEntry?.approved === 'WAITING') {
      // Inicia el efecto después de un retraso de 15 segundos
      timeout = setTimeout(() => {
        startBlinkEffect(initialDuration, totalEffectTime)
      }, 15000) // Espera 15 segundos antes de empezar el parpadeo
    } else if (
      lastEntry &&
      ['APPROVED', 'REJECT', 'RECESSION', 'LEAVE', 'NO_LEAVE', 'UNANSWERED'].includes(
        `${lastEntry?.approved}`
      )
    ) {
      clearAndFocusTime(15000)
    }

    return () => {
      if (timeout) clearTimeout(timeout) // Limpiar el timeout cuando el componente se desmonta
      setBlinkDuration(initialDuration) // Restaurar la duración inicial
    }
  }, [lastEntry])

  useEffect(() => {
    if (searchedValue.length) {
      getDataCodes()
    }
  }, [searchedValue])

  useEffect(() => {
    if (!images.photo && !images.DNI_A) return
    if (TimeImg) clearTimeout(TimeImg)

    if (lastEntry && lastEntry.approved !== 'WAITING') {
      allClean()
    }

    setTimeImg(
      setTimeout(() => {
        if (images.DNI_A || images.photo) return allClean()
      }, 30000)
    )

    return () => {
      console.log('resetTime')
      if (TimeImg) clearTimeout(TimeImg)
    }
  }, [images, formValues])

  const options = user?.canApprove
    ? [
        {
          label: 'Autorizar Ingreso',
          newStatus: 'APPROVED',
          icon: CheckCircleOutlined,
          colorSvg: 'green'
        },
        {
          label: 'No se espera visita',
          newStatus: 'REJECT',
          icon: CloseCircleOutlined,
          colorSvg: 'red'
        },
        {
          label: 'Espera en recepcion',
          newStatus: 'RECESSION',
          icon: waitInLobby
        },
        {
          label: 'Dejar paqueteria',
          newStatus: 'LEAVE',
          icon: leaveInLobby
        },
        {
          label: 'No espera paqueteria',
          newStatus: 'NO_LEAVE',
          icon: noLeaveInLobby
        },
        {
          label: 'VISITA DESATENDIDA',
          newStatus: 'UNANSWERED',
          icon: CloseCircleOutlined,
          colorSvg: 'red'
        }
      ]
    : [
        {
          label: 'VISITA DESATENDIDA',
          newStatus: 'UNANSWERED',
          icon: CloseCircleOutlined,
          colorSvg: 'red'
        }
      ]

  // Obtiene los datos de códigos de destino según la búsqueda
  const getDataCodes = async () => {
    try {
      const values = await listByDestinationCode({
        search: searchedValue,
        clientId: user?.clientId as string
      })
      setOptionsDestinations(
        values.map(e => ({
          label: `${e.destinationCode} ${e.name} ${e.lastName}`,
          value: e.destinationCode
        }))
      )
    } catch (error) {
      console.error('Error fetching destination codes:', error)
    }
  }

  const allClean = () => {
    if (TimeImg) clearTimeout(TimeImg)
    setFormValues(old => ({ ...old, destinationCode: '' }))
    setImages({
      photo: null,
      DNI_A: null
      // DNI_B: null
    })
    setlastEntry(null)
    setOkEntry(false)
  }

  const clearAndFocusTime = (Timer: number) => {
    setTimeout(() => {
      if (selectRef.current) {
        allClean()
        selectRef.current.focus() // Enfocar el campo de texto automáticamente
      }
    }, Timer) //
  }

  const statusSvg: {
    [key: string]: React.JSX.Element
  } = {
    WaitImgScam: (
      <Loading3QuartersOutlined
        style={{
          fontSize: '8rem',
          color: '#f600c0',
          animation: `rotate linear 1s infinite`
        }}
      />
    ),

    WaitQr: (
      <QrcodeOutlined
        style={{
          fontSize: '8rem',
          color: '#f600c0',
          animation: `rotate linear 2s infinite`
        }}
      />
    ),

    WAITING: (
      <ContextMenu options={options} lastEntry={lastEntry} setlastEntry={setlastEntry}>
        <LightTooltip
          title={
            lastEntry?.name || lastEntry?.lastName
              ? `${lastEntry?.name ? lastEntry.name : ''} ${
                  lastEntry?.lastName ? lastEntry.lastName : ''
                }`
              : undefined
          }
          TransitionComponent={Fade}
          disableHoverListener={lastEntry?.name ? false : true}
        >
          <div>
            <ClockCircleOutlined
              style={{
                color: 'yellow',
                animation: blinkDuration !== 5 ? `blink linear ${blinkDuration}s infinite` : ''
              }}
            />
          </div>
        </LightTooltip>
      </ContextMenu>
    ),
    CALLING: (
      <ContextMenu options={options} lastEntry={lastEntry} setlastEntry={setlastEntry}>
        <LightTooltip
          title={
            lastEntry?.name || lastEntry?.lastName
              ? `${lastEntry?.name ? lastEntry.name : ''} ${
                  lastEntry?.lastName ? lastEntry.lastName : ''
                }`
              : undefined
          }
          TransitionComponent={Fade}
        >
          <PhoneOutlined style={{ color: 'green', fontSize: '7rem' }} />
        </LightTooltip>
      </ContextMenu>
    ),
    APPROVED: <LikeOutlined style={{ color: 'green' }} />,
    REJECT: <DislikeOutlined style={{ color: 'red' }} />,
    RECESSION: <Icon component={waitInLobby} />,
    LEAVE: <Icon component={leaveInLobby} />,
    NO_LEAVE: <Icon component={noLeaveInLobby} />,
    UNANSWERED: <CloseCircleOutlined style={{ color: 'red' }} />
  }

  const handleCheckIn = async () => {
    try {
      if (TimeImg) clearTimeout(TimeImg)

      startLoading()
      const formData = new FormData()

      Object.entries(formValues).forEach(([key, value]) => {
        formData.append(key, value)
      })
      Object.entries(images).forEach(([key, value]) => {
        formData.append(key, value as Blob)
      })
      formData.append('clientId', user?.clientId as string)

      const getData = async () => {
        try {
          const visitor = await createVisitor(formData, token)
          if (visitor) {
            toast.success('El check-in se registró correctamente', {
              description: `${visitor.name} ${visitor.lastName}`,
              position: 'top-right'
            })
          } else {
            toast.success('El check-in se registró correctamente', {
              position: 'top-right'
            })
          }
          return visitor
        } catch (error: any) {
          if (error?.response?.data?.msg) {
            toast.warning(`${error?.response?.data?.msg}`, {
              position: 'top-right'
            })
            throw new Error(`${error?.response?.data?.msg}`)
          } else if (error?.response?.status === 400) {
            toast.warning(`Falta información`, {
              position: 'top-right'
            })
            throw new Error(`${error?.response?.data?.msg}`)
          } else {
            toast.error(`Error desconocido`, {
              position: 'top-right'
            })
            throw new Error(`${error?.response?.data?.msg}`)
          }
        }
      }

      // Llamar a la función al montar el componente
      const entry = await getData()
      setlastEntry(entry)
      setOkEntry(true)
      await printQRCode(entry.qrCode as string, entry, user?.client?.name || '')
    } catch (error) {
      console.error('API Error:', error)
    } finally {
      stopLoading()
    }
  }

  // Maneja el cambio de valores del formulario
  const handleInputChange = (inputName: string, value: string) => {
    setFormValues({
      ...formValues,
      [inputName]: value
    })
  }

  const MyGradientArrow = () => {
    return (
      <svg className="my-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style={{ stopColor: '#f600c0', stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: '#4409a4', stopOpacity: 1 }} />
          </linearGradient>
        </defs>
        <DoubleArrowIcon className="gradient-fill" />
      </svg>
    )
  }

  const ModalLaterals: React.FC = () => {
    const type = lastEntry?.qrCode?.slice(0, 4) as keyof typeof typeQrEnumAbbreviationString
    const values = typeQrEnumAbbreviationString[type]

    const handleIconColor = (value: entriesApprovedEnum) =>
      ({
        [entriesApprovedEnum.APPROVED]: (
          <div className="green circle" style={{}}>
            <p>{values}</p>
          </div>
        ),
        [entriesApprovedEnum.CALLING]: (
          <div className="yellow circle" style={{}}>
            <p>{values}</p>
          </div>
        ),
        [entriesApprovedEnum.WAITING]: (
          <div className="yellow circle" style={{}}>
            <p>{values}</p>
          </div>
        ),
        [entriesApprovedEnum.REJECT]: (
          <div className="red circle" style={{}}>
            <p>{values}</p>
          </div>
        ),
        [entriesApprovedEnum.UNANSWERED]: (
          <div className="red circle" style={{}}>
            <p>{values}</p>
          </div>
        ),
        [entriesApprovedEnum.LEAVE]: (
          <div className="yellow circle" style={{}}>
            <p>{values}</p>
          </div>
        ),
        [entriesApprovedEnum.NO_LEAVE]: (
          <div className="red circle" style={{}}>
            <p>{values}</p>
          </div>
        ),
        [entriesApprovedEnum.RECESSION]: (
          <div className="yellow circle" style={{}}>
            <p>{values}</p>
          </div>
        )
      }[value])
    return (
      <>
        <div className="modal-laterals-header">
          <span className="textHeader">
            <strong>{lastEntry?.destination}</strong>
          </span>
          <span>INDICA:</span>
          <div className="stylesImgsvg">
            {statusSvg[lastEntry?.approved as entriesApprovedEnum]}
            {brandPhoto ? (
              <img src={brandPhoto} alt="foto de marca" />
            ) : lastEntry?.qrCode ? (
              handleIconColor(lastEntry?.approved as entriesApprovedEnum)
            ) : (
              <PlaceholderSvg />
            )}
          </div>
        </div>
        <div className="modal-laterals-foother">
          <strong>
            {lastEntry?.name ? lastEntry.name : ''}
            {' ' /* se deja espacio para separar nombres */}
            {lastEntry?.lastName ? lastEntry.lastName : ''}
          </strong>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="containerModalCamera-CheckInCenter">
        <h3>{camera.name}</h3>
        <div className="modal-sections-CheckInCenter">
          <div className="container-cameras-CheckInCenter">
            {
              <NewCameraFiles
                loading={setloadingCamera}
                onSubmitImage={value => setImages((old: any) => ({ ...old, photo: value }))}
                text="Foto del rostro"
                file={camera.FileFace}
                watch={images.photo}
                okEntry={okEntry}
                defaultImg="/images/logo-ipass-clear.webp"
                setlastEntry={setlastEntry}
                nameCamera={camera.name}
                TimeClearqr={TimeClearqr}
              />
            }
            {
              <NewCameraFiles
                loading={setloadingCamera}
                onSubmitImage={value => setImages((old: any) => ({ ...old, DNI_A: value }))}
                text="DNI frontal"
                file={camera.FileDNI1}
                watch={images.DNI_A}
                okEntry={okEntry}
                defaultImg="/images/logo-ipass-clear.webp"
                setlastEntry={setlastEntry}
                nameCamera={camera.name}
                TimeClearqr={TimeClearqr}
              />
            }
          </div>
          <div className="container-Inputs-CheckInCenter">
            <AutoComplete
              icon={'images/icons/brands.png'}
              label="Marcas"
              options={brands.map(e => ({ value: e.id, label: e.name }))}
              value={formValues.brand}
              onChange={value => {
                handleInputChange('brand', value)
                localStorage.setItem(`${camera.name}SelectBrand2`, value)
              }}
            />

            <AutoComplete
              icon={'images/icons/user.png'}
              label="Destino"
              options={optionsDestinations}
              onChangeText={value => {
                setSearchedValue(value)
              }}
              value={formValues.destinationCode}
              ref={selectRef} // Pasamos la referencia al CustomSelect
              onChange={value => {
                handleInputChange('destinationCode', value)
                setSearchedValue('')
              }}
            />
          </div>
          <div className="button-section-CheckInCenter">
            {(() => {
              const isCheckInButtonDisabled =
                !images.photo || !images.DNI_A || !formValues.destinationCode

              const showCheckInButton = !lastEntry && !loadingCamera
              const showWaitImgScam = loadingCamera
              const showWaitQr = !loadingCamera && lastEntry?.qrCode && !lastEntry?.approved
              const showApprovedStatus =
                !loadingCamera && ['WAITING', 'CALLING'].includes(lastEntry?.approved!)
              const showModalLaterals =
                !loadingCamera &&
                [
                  'APPROVED',
                  'REJECT',
                  'RECESSION',
                  'LEAVE',
                  'NO_LEAVE',
                  'UNANSWERED'
                ].includes(`${lastEntry?.approved}`)

              if (showCheckInButton) {
                return (
                  <Button
                    disabled={isCheckInButtonDisabled}
                    style={isCheckInButtonDisabled ? { pointerEvents: 'none' } : {}}
                    onClick={handleCheckIn}
                    icon={isCheckInButtonDisabled ? <DoubleArrowIcon /> : <MyGradientArrow />}
                  />
                )
              }
              if (showWaitImgScam) return statusSvg.WaitImgScam
              if (showWaitQr) return statusSvg.WaitQr
              if (showApprovedStatus) return statusSvg[lastEntry?.approved!]
              if (showModalLaterals) return <ModalLaterals />
              return null
            })()}
          </div>
        </div>
      </div>

      <Toaster richColors />
    </>
  )
}

export default ModalCheckInCenter
